import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { abilityPlugin, ability as appAbility } from './ability';
import subscribers from './subscribers';

Vue.use(Vuex);

// Load store modules dynamically.
const requireContext = require.context('./modules', false, /.*\.js$/);

const modules = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
  .reduce((allModules, [name, module]) => {
    allModules[name] = module;
    return allModules;
  }, {});

export const ability = appAbility;

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules,
  plugins: [createPersistedState(), abilityPlugin, subscribers],
});